import { Localized } from "@fluent/react"
import { Alert, Button, Container, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Skeleton, Stack, Typography } from "@mui/material"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { LoadProfile } from "../../app/AppDataLoader"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { Module, selectAllModules, selectModule, setCurrentModule } from "./moduleSlice"

export const Modules = () => {
    return <LoadProfile component={<Skeleton />}>
        <SelectModule />
    </LoadProfile>
}

const SelectModule = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const allModules = useAppSelector(selectAllModules)
    const currentModule = useAppSelector(state => selectModule(state).currentModule)
    const modules = useAppSelector(state => selectModule(state).entities)

    const [module, setModule] = useState<Module | null>(() => {
        const fstActiveModule = allModules.find(m => m.isActive)

        if (currentModule) {
            return currentModule
        } else if (fstActiveModule) {
            return fstActiveModule
        }

        return  null
    })

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selected = modules[(event.target as HTMLInputElement).value] as Module
        setModule(selected)
    }

    const handleOKClick = () => {
        if (module) {
            dispatch(setCurrentModule(module))
            navigate('/')
        }
    }

    if (allModules.length === 0) return <NoModules />

    return <Container maxWidth='xs' sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
    }}>
        <Stack spacing={2}>
            <FormControl>
                <FormLabel>
                    <Typography variant="caption">
                        <Localized id="module-select">
                            <span>Wybierz moduł</span>
                        </Localized>
                    </Typography>
                </FormLabel>
                <RadioGroup value={module?.code} onChange={handleChange}>
                    {allModules.map(({ code, name, isActive }) => <FormControlLabel key={code} value={code} control={<Radio disabled={!isActive} />} label={name} />)}
                </RadioGroup>
            </FormControl>
            <Button disabled={module === null} fullWidth variant="contained" onClick={handleOKClick}>
                <Localized id="ok">
                    <span>OK</span>
                </Localized>
            </Button>
        </Stack>
    </Container>
}

const NoModules = () => {
    return <Alert severity='warning'>
        <Localized id="module=no-modules">
            <span>Brak modułów</span>
        </Localized>
    </Alert>
}
